import React from "react";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export function Loader({ label, className, tone = "sage" }) {
  return (
    <div className={cn("flex flex-col items-center justify-center gap-3 py-16", className)}>
      <Loader2 className={cn("h-7 w-7 animate-spin", tone === "cream" ? "text-cream" : "text-sage")} />
      {label && <p className="text-sm text-ink-muted">{label}</p>}
    </div>
  );
}

export function Chip({ label, selected, onClick, testId }) {
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onClick}
      className={cn(
        "rounded-full px-4 py-2 text-sm font-medium transition-all duration-200 border",
        selected
          ? "bg-ink text-cream border-ink shadow-sm"
          : "bg-cardbg text-ink border-cardborder hover:border-sage hover:-translate-y-0.5"
      )}
    >
      {label}
    </button>
  );
}

export function PrimaryButton({ children, className, ...props }) {
  return (
    <button
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded-full bg-sage px-6 py-3 font-semibold text-white shadow-sm transition-all duration-200 hover:bg-sage-hover hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 active:scale-[0.98] disabled:opacity-50 disabled:pointer-events-none",
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}

export function DarkButton({ children, className, ...props }) {
  return (
    <button
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded-full bg-ink px-6 py-3 font-semibold text-cream transition-all duration-200 hover:bg-ink-soft hover:-translate-y-0.5 active:translate-y-0 disabled:opacity-50 disabled:pointer-events-none",
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}

export function GhostButton({ children, className, ...props }) {
  return (
    <button
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded-full border border-cardborder bg-transparent px-6 py-3 font-semibold text-ink transition-all duration-200 hover:bg-cream-alt hover:border-sage disabled:opacity-50 disabled:pointer-events-none",
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}

const STATE_STYLES = {
  "Improving": "bg-sage-light text-sage-hover border-sage/40",
  "Confirmed pattern": "bg-clay-light text-clay border-clay/30",
  "Emerging pattern": "bg-amberx-light text-amberx border-amberx/40",
  "Possible pattern": "bg-slatex-light text-slatex border-slatex/30",
  "Inactive": "bg-cream-alt text-ink-muted border-cardborder",
};

export function PatternTag({ state, count }) {
  return (
    <span className={cn("inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-mono font-medium border", STATE_STYLES[state] || STATE_STYLES["Possible pattern"])}>
      {state}{count != null ? ` · ${count}` : ""}
    </span>
  );
}
